import PropTypes from 'prop-types'
import { Fragment } from 'react'

import { press, smooth, step } from '../springs'
import { Avatar, I, Icon, at, edges, lerpX, show, typed } from './common'

/*
 * Szene 1: Das Team braucht jemanden. HR legt die Stelle an und wählt, ob es
 * Kolleg:innen befragt oder eine Aivy-Vorlage verwendet. Hier die Vorlage,
 * daraus entsteht sofort das Anforderungsprofil.
 */

export const ASK_AT = 3.5
export const ASK_BTN = [-106, 62]
export const OPT_A = [-113, 40]
export const OPT_B = [113, 40]
export const PICK_AT = 6.5
export const TPL_ROW = [-100, 4]
export const TPL_AT = 8.25
export const PROFILE_BTN = [-170, 142]
export const INVITE_AT = 11

const QUERY = 'Account'
const TYPE_AT = 6.9
const BX0 = -248
const BX1 = 248
export const DIMS = [
  ['Problemlösefähigkeit', 70, 90],
  ['Kommunikation', 75, 95],
  ['Sorgfalt', 55, 75],
  ['Belastbarkeit', 50, 70]
]
// Übergangsbereich liegt um den Idealbereich herum
export const TRANSIT = 10
const PROW = (i) => -70 + i * 54

function Need() {
  return (
    <>
      <span className='mo-ic mo-ic--blue' style={at(-172, -18)}>
        <Icon d={I.users} size={18} />
      </span>
      <span className='mo-title' style={at(-122, -19)}>
        Team Vertrieb braucht Verstärkung
      </span>
      <span className='mo-sub' style={at(-122, 1)}>
        Neue Nachricht von Tim K.
      </span>
    </>
  )
}

function Ask() {
  return (
    <>
      <Avatar name='Tim K' size={40} tone='light' style={at(-196, -82)} />
      <span className='mo-title' style={at(-144, -81)}>
        Tim K.
      </span>
      <span className='mo-sub' style={at(-144, -61)}>
        Teamleitung Vertrieb
      </span>
      <span className='mo-meta mo-right' style={at(196, -80)}>
        vor 2 Min.
      </span>
      <span className='mo-text' style={at(-196, -24)}>
        Wir brauchen eine:n Account Manager:in,
      </span>
      <span className='mo-text' style={at(-196, -2)}>
        gern schnell, Start ab Q1.
      </span>
      <span className='mo-btn' data-mo='ask-btn' style={at(-196, 44)}>
        <Icon d={I.plus} size={16} width={2} />
        Neue Stelle anlegen
      </span>
    </>
  )
}

function Loader() {
  return (
    <svg
      data-mo='spinner'
      width='28'
      height='28'
      viewBox='0 0 28 28'
      style={at(-14, -14)}
    >
      <circle
        cx='14'
        cy='14'
        r='11'
        fill='none'
        stroke='#EBEFFD'
        strokeWidth='3'
      />
      <path
        d='M14 3a11 11 0 0 1 11 11'
        fill='none'
        stroke='#4461D4'
        strokeWidth='3'
        strokeLinecap='round'
      />
    </svg>
  )
}

function Option({ x, data, icon, title, sub, badge }) {
  return (
    <span className='mo-opt' data-mo={data} style={at(x, -30)}>
      <span className='mo-opt__ic'>
        <Icon d={icon} size={17} />
      </span>
      {badge && <span className='mo-badge mo-badge--blue'>{badge}</span>}
      <span className='mo-title'>{title}</span>
      <span className='mo-sub'>{sub}</span>
    </span>
  )
}

Option.propTypes = {
  x: PropTypes.number.isRequired,
  data: PropTypes.string.isRequired,
  icon: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  sub: PropTypes.string.isRequired,
  badge: PropTypes.string
}

function Setup() {
  return (
    <>
      <span className='mo-meta' style={at(-218, -108)}>
        Stellen · Account Manager Vertrieb
      </span>
      <span className='mo-h' style={at(-218, -90)}>
        Anforderungsprofil erstellen
      </span>
      <span className='mo-sub' style={at(-218, -64)}>
        Wie möchtest du starten?
      </span>
      <Option
        x={-218}
        data='opt-a'
        icon={I.users}
        title='Kolleg:innen befragen'
        sub='5 Min. pro Person'
      />
      <Option
        x={8}
        data='opt-b'
        icon={I.template}
        title='Aivy-Vorlage verwenden'
        sub='Sofort startklar'
        badge='Empfohlen'
      />
    </>
  )
}

function Template() {
  return (
    <>
      <span className='mo-h' style={at(-218, -112)}>
        Vorlage auswählen
      </span>
      <span className='mo-input' style={at(-218, -80)}>
        <span className='mo-input__ic'>
          <Icon d={I.search} size={16} />
        </span>
        <span data-mo='tp-typed' />
        <span className='mo-caret' data-mo='tp-caret' />
      </span>
      <span
        className='mo-hi'
        data-mo='tp-hi'
        style={{ ...at(-226, -26), width: 452, height: 56 }}
      />
      <span className='mo-trow' data-mo='tp-row' style={at(-212, -18)}>
        <span className='mo-title'>Account Manager Vertrieb</span>
        <span className='mo-sub'>Anforderungsprofil nach DIN 33430</span>
      </span>
      <span
        className='mo-badge mo-badge--blue mo-right'
        data-mo='tp-tag'
        style={at(212, -9)}
      >
        Vorlage von Aivy
      </span>
      <span className='mo-trow' data-mo='tp-row' style={at(-212, 46)}>
        <span className='mo-title'>Key Account Manager</span>
        <span className='mo-sub'>Anforderungsprofil nach DIN 33430</span>
      </span>
    </>
  )
}

function Profile() {
  return (
    <>
      <span className='mo-h' style={at(-248, -150)}>
        Anforderungsprofil
      </span>
      <span className='mo-badge mo-badge--blue mo-right' style={at(248, -148)}>
        Vorlage von Aivy
      </span>
      <span className='mo-sub' style={at(-248, -124)}>
        Account Manager Vertrieb · jederzeit anpassbar
      </span>
      {DIMS.map(([label], i) => (
        <Fragment key={label}>
          <span className='mo-cap' style={at(BX0, PROW(i) - 24)}>
            {label}
          </span>
          <span
            className='mo-bar'
            style={{ ...at(BX0, PROW(i) - 4), width: BX1 - BX0 }}
          />
          <span
            className='mo-band mo-band--transit'
            data-mo='pf-transit'
            style={{ top: PROW(i) - 4 }}
          />
          <span
            className='mo-band mo-band--ideal'
            data-mo='pf-ideal'
            style={{ top: PROW(i) - 4 }}
          />
        </Fragment>
      ))}
      <span className='mo-btn' data-mo='pf-btn' style={at(-248, 124)}>
        Talente einladen
        <Icon d={I.arrow} size={16} width={2} />
      </span>
    </>
  )
}

function Invited() {
  return (
    <>
      <span className='mo-ic mo-ic--green' style={at(-172, -18)}>
        <Icon d={I.check} size={18} width={2} />
      </span>
      <span className='mo-title' style={at(-122, -19)}>
        Einladungslink verschickt
      </span>
      <span className='mo-sub' style={at(-122, 1)}>
        24 Talente eingeladen
      </span>
    </>
  )
}

export const NEED_CONTENTS = {
  need: Need,
  ask: Ask,
  loader: Loader,
  setup: Setup,
  template: Template,
  profile: Profile,
  invited: Invited
}

const placeBand = (node, lo, hi) => {
  const x0 = lerpX(BX0, BX1, Math.max(0, lo))
  const x1 = lerpX(BX0, BX1, Math.min(100, hi))
  node.style.left = `${x0.toFixed(2)}px`
  node.style.width = `${Math.max(0, x1 - x0).toFixed(2)}px`
}

export function buildNeed({ q, qa }) {
  const askBtn = q('ask-btn')
  const spinner = q('spinner')
  const optA = q('opt-a')
  const optB = q('opt-b')
  const typedEl = q('tp-typed')
  const caret = q('tp-caret')
  const rows = qa('tp-row')
  const hi = q('tp-hi')
  const tag = q('tp-tag')
  const transit = qa('pf-transit')
  const ideal = qa('pf-ideal')
  const pfBtn = q('pf-btn')

  // Ideal- und Übergangsbereich ziehen sich aus der Mitte auf
  const bandEdges = DIMS.map(([, lo, hi2], i) => {
    const c = (lo + hi2) / 2
    const t0 = 8.7 + i * 0.14
    return [
      edges({ L: c, R: c }, [
        { t: t0 + 0.08, L: lo - TRANSIT, R: hi2 + TRANSIT }
      ]),
      edges({ L: c, R: c }, [{ t: t0, L: lo, R: hi2 }])
    ]
  })

  return (t) => {
    askBtn.style.transform = `scale(${(1 - 0.05 * press(t, ASK_AT - 0.06)).toFixed(3)})`
    spinner.style.transform = `rotate(${((t * 520) % 360).toFixed(1)}deg)`

    // Zwei Wege: Hover auf „Kolleg:innen befragen“, Klick auf die Vorlage
    const hoverA = smooth((t - 5.45) / 0.15) * (1 - smooth((t - 5.95) / 0.15))
    optA.style.backgroundColor = `rgb(${Math.round(255 - 10 * hoverA)},${Math.round(255 - 8 * hoverA)},${Math.round(255 - 5 * hoverA)})`
    const sel = step(t - PICK_AT, 22, 0.8)
    optB.style.boxShadow =
      sel > 0.5
        ? `inset 0 0 0 ${(1 + sel).toFixed(2)}px #4461D4`
        : 'inset 0 0 0 1px #E5E7EB'
    optB.style.transform = `scale(${(1 - 0.04 * press(t, PICK_AT - 0.06)).toFixed(3)})`

    // Vorlage suchen
    typedEl.textContent = t < TYPE_AT ? '' : typed(t, QUERY, TYPE_AT)
    const typing = t >= TYPE_AT && t < TYPE_AT + QUERY.length * 0.06 + 0.3
    caret.style.opacity = typing || Math.floor(t * 2.4) % 2 === 0 ? '1' : '0'
    rows.forEach((row, i) => show(row, smooth((t - (7.15 + i * 0.12)) / 0.2)))
    show(tag, smooth((t - 7.4) / 0.2))
    show(hi, smooth((t - 7.75) / 0.18))
    hi.style.transform = `scale(${(1 - 0.02 * press(t, TPL_AT - 0.06)).toFixed(3)})`

    bandEdges.forEach(([tr, id], i) => {
      placeBand(transit[i], ...tr(t))
      placeBand(ideal[i], ...id(t))
    })
    show(pfBtn, smooth((t - 9.8) / 0.22))
    pfBtn.style.transform = `scale(${(1 - 0.05 * press(t, INVITE_AT - 0.06)).toFixed(3)})`
  }
}

export const NEED_IDS = Object.keys(NEED_CONTENTS)
